import Reveal from '../ui/Reveal';

export default function ApproachSection() {
  return (
    <section id="approach" className="scroll-mt-24 py-24">
      <div className="container-page grid grid-cols-1 items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <img
            src="/piua3.jpeg"
            alt="A Piua AI user working calmly at their desk with coffee, laptop, and phone"
            className="w-full rounded-2xl border border-line object-cover shadow-card dark:border-midnight-600"
            loading="lazy"
          />
        </Reveal>

        <Reveal delay={0.1} className="flex flex-col items-start gap-6 text-left">
          <span className="section-eyebrow">Our approach</span>
          <p className="text-2xl font-semibold leading-snug tracking-tight text-ink dark:text-white sm:text-3xl">
            "AI should make you faster without making you less careful."
          </p>
          <p className="text-base leading-relaxed text-muted dark:text-subtle">
            Rather than asking teams to remember not to paste in a client's name or a contract figure, Piua AI
            handles that automatically, every time — so good privacy hygiene isn't something your team has to
            think about.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
